module.exports = __webpack_public_path__ + "static/media/uspx.e78c1488.png";